/**
 * Context Tag Badge
 * 
 * Displays a neutral gray chip for context tags per spec.
 * No semantic colors, no icons per customer.
 * Read-only display component.
 */

import { Badge } from "@/components/ui/badge";

interface ContextTagBadgeProps {
  tag: string;
}

export function ContextTagBadge({ tag }: ContextTagBadgeProps) {
  if (!tag) return null;

  return (
    <Badge 
      variant="secondary"
      className="bg-muted/60 text-muted-foreground hover:bg-muted/60 px-1.5 py-0 text-[10px] font-normal"
    >
      {tag}
    </Badge>
  );
}
